import { produce } from 'immer';

import { CloseImagesInternalGallery } from '../../../actions/imageEditor/internal/closeImagesInternalGallery';
import { getImageEditorIdByBannerId } from '../../../service/ImageHelpers/ImageHelpers';
import { ImageEditorsState } from '../../../typings/state';

export function closeImagesInternalGallery(
    state: ImageEditorsState,
    action: CloseImagesInternalGallery
): ImageEditorsState {
    const id = getImageEditorIdByBannerId(action.bannerId, action.resourceId);

    return produce(state, draft => {
        draft[id].imageGallery = {
            isImageGalleryOpen: false,
            selectedImageHashFromGallery: []
        };
    });
}
